import React from 'react';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';
import { Button } from '~/Partials/Button/Button';
import { ButtonSize } from '~/Partials/Button/ButtonSize.csharp';
import { ButtonTier } from '~/Partials/Button/ButtonTier.csharp';
import { ButtonType } from '~/Partials/Button/ButtonType.csharp';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './BookMeetingFormConfirmation.module.css';

export interface BookMeetingFormConfirmationProps {
    heading: string;
    buttonLabel: string;
    onClick: () => void;
    confirmationMessage?: HtmlString;
}

export const BookMeetingFormConfirmation: React.FC<
    React.PropsWithChildren<BookMeetingFormConfirmationProps>
> = props => {
    const { heading, confirmationMessage, buttonLabel, onClick } = props;

    return (
        <div>
            <h2 className={styles.Heading}>{heading}</h2>
            <div className={styles.Content}>
                <SvgIcon iconName="check-circle" className={styles.SvgIcon} />
                {confirmationMessage && <HtmlDiv className={styles.ConfirmationMessage} html={confirmationMessage} />}
                <Button
                    className={styles.Button}
                    size={ButtonSize.Medium}
                    type={ButtonType.Solid}
                    tier={ButtonTier.Tertiary}
                    onClick={onClick}
                >
                    {buttonLabel}
                </Button>
            </div>
        </div>
    );
};
